<owc-card class="one-card-flat" style="position:relative">

  <owc-table>
    <owc-table-header sticky>
      <owc-table-header-cell>
        <owc-checkbox style="height: 25px;" [checked]="isAllSelected()" [indeterminate]="isIndeterminate()"
          (change)="masterToggle()">
        </owc-checkbox>
      </owc-table-header-cell>

      @for(column of selectedRecepientColumns; track column.value) {
      <owc-table-header-cell sortable [align]="'left'" [title]="column.key" (sortOrderChange)="OnSort(column.value, $event.detail)">
        {{ column.key }}
      </owc-table-header-cell>
      }


      <owc-table-header-cell></owc-table-header-cell>
    </owc-table-header>


    <owc-table-body>
      @if(dataSource?.length > 0) {
  @for(row of dataSource; track $index) {
  <owc-table-row (click)="gotoContactDetailsPage(row)" [ngClass]="{ 'removed-row': row.Status=='Removed' }" style="cursor: pointer;">


        <owc-table-simple-cell>
          <owc-checkbox (click)="$event.stopPropagation()" (change)="toggleSelection(row)" [checked]="isSelected(row)"
            [disabled]="row.disabled">
          </owc-checkbox>
        </owc-table-simple-cell>


        @for(column of selectedRecepientColumns; track column.value) {
        <owc-table-simple-cell [title]="row[column.value]" class="truncate-text" style="cursor: pointer;">


          <div class="truncate-text" *ngIf="column.value != 'Status'; else displayStatusChip">


            <span [title]="row[column.value]" class="truncate-text" *ngIf="column.value == 'CustomerContactName' || column.value == 'CustomerContactEmail'; 
                               else displayDateField ">
              {{ row[column.value] }}
            </span>


            <ng-template #displayDateField class="truncate-text">
              <div [ngSwitch]="column.value" class="truncate-text">
                <span [title]="getReminderSent(row.CustomerReminderDetails)" class="truncate-text"
                  *ngSwitchCase="'ReminderSent'">
                  {{ getReminderSent(row.CustomerReminderDetails) }}
                </span>
                <span [title]="getReminderPlanned(row.CustomerReminderDetails)" class="truncate-text"
                  *ngSwitchCase="'ReminderPlanned'">
                  {{ getReminderPlanned(row.CustomerReminderDetails) }}
                </span>
                <span [title]="row.InternalContact === true ? 'Internal' : ''" class="truncate-text"
                  *ngSwitchCase="'InternalContact'">
                  {{ row.InternalContact === true ? 'Internal' : '' }}
                </span>
                <span [title]="appUtils.formatDateWithTime(row[column.value])" class="truncate-text" *ngSwitchDefault>
                  {{ appUtils.formatDateWithTime(row[column.value]) }}
                </span>
              </div>
            </ng-template>

          </div>


          <ng-template #displayStatusChip class="truncate-text">
            <owc-chip [ngClass]="appUtils.getColor(row.Status)" [title]="row.Status" class="notification-list-source-chip">
              <span class="ellipsis" style="cursor: pointer;">
                {{ displayStatus(row.Status) }}
              </span>
            </owc-chip>
          </ng-template>

        </owc-table-simple-cell>
        }


        <owc-table-simple-cell style="display: flex; align-items: center; justify-content: center; cursor: pointer;">
          <owc-icon name="chevron_right" family="outlined" (click)="$event.stopPropagation(); gotoContactDetailsPage(row)" style="cursor: pointer;"></owc-icon>
        </owc-table-simple-cell>
      </owc-table-row>
      }
      }
    </owc-table-body>


    <owc-footer class="table-footer">
      <div style="display: flex;">
        <owc-button (click)="ndResendNotification()" [disabled]="selectedRows.size < 1 || notificationDetails.notificationData[0].Status === 'Superseded'"
          *ngIf="userPermission.SendNotification && !isAddRecipientDisabled && !isSetCom && !isSetCancelled"
          style="margin: 10px;">
          Resend notifications
        </owc-button>
        <owc-button (click)="deleteContacts()" [disabled]="selectedRows.size < 1 || notificationDetails.notificationData[0].Status === 'Superseded' || notificationDetails.notificationData[0].Status === 'Cancelled' || notificationDetails.notificationData[0].Status === 'Completed' || wrongItemSelectedToDelete.length>0"
          *ngIf="userPermission.SendNotification && !isAddRecipientDisabled && !isSetCom"
          style="margin: 10px;">
          Delete
        </owc-button>
      </div>
    </owc-footer>

  </owc-table>

  <owc-modal-dialog size="large" [(ngModel)]="visibleResendDialog">
    <dl-resend-details size="large" [data]="data" (closed)="visibleResendDialog = false"></dl-resend-details>

  </owc-modal-dialog>

  <!-- Notice Dialog Modal -->
  <owc-modal-dialog [(ngModel)]="visibleDeleteNote" size="small" disable-backdrop-click="true" disable-escape-keydown="true">
    <dl-delete-contact (onClose)="onNoticeDialogClose($event)" (reasonSubmitted)="receivedConfirmation($event)" [data]="deletedData"></dl-delete-contact>
  </owc-modal-dialog>

  <div class="noDataViewRecipient" *ngIf="contactDetails?.length < 1 || dataSource?.length < 1">
    <ng-container *ngIf="contactDetails?.length < 1; else noFilteredData">
      No data available.
    </ng-container>
    <ng-template #noFilteredData>
      <ng-container *ngIf="dataSource?.length < 1">
        No data available with given filter or search criteria.
      </ng-container>
    </ng-template>
  </div>

</owc-card>